// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__JwJyp","productName":"Table_productName__hdfO8"};